/* eslint-disable */

const globalFunctions = {
    methods: {
        async saveData(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal, titleLoading, titleMessage, emitMessage) {
            this.openLoading('Espera por favor...')
            if(modelOriginal == null)
                model.append("_method", "post")
            await axios.post(apiKS + url, model, { headers: this.$store.getters.headers })
                .then( response => {
                    Swal.close()
                    if(response.data.status == true){
                        this.showMessage('Exito', response.data.message, 'success', urlReturn, emitMessage, emitEvent, response)
                        if(closemodal)
                            this.closeModal()

                        return
                    }

                    if(response.data.status == false){
                        this.showMessage('Error', response.data.message, 'error', '', emitMessage, emitEvent, response)
                        return
                    }

                    // if(response.data.data !== undefined) {
                    //     if(response.data.data.status == true){
                    //         this.showMessage('Exito', response.data.data.message, 'success', urlReturn, emitMessage, emitEvent, response)
                    //         this.$emit('success')
                    //         if(closemodal)
                    //             this.closeModal()
                    //     }

                    //     return
                    // }
                })
                .catch( error => {
                    this.catchError(error)
                })
        },

        async updateData(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal, titleLoading, titleMessage, emitMessage) {
            this.openLoading('Espera por favor...')
            if(modelOriginal == null)
                model.append("_method", "post")
            await axios.put(apiKS + url, model, { headers: this.$store.getters.headers })
                .then( response => {
                    Swal.close()
                    if(response.data.status == true){
                        this.showMessage('Exito', response.data.message, 'success', urlReturn, emitMessage, emitEvent, response)
                        this.$emit('success')
                        if(closemodal)
                            this.closeModal()

                        return
                    }
                    // if(response.data.data !== undefined) {
                    //     if(response.data.data.status == true){
                    //         this.showMessage('Exito', response.data.data.message, 'success', urlReturn, emitMessage, emitEvent, response)
                    //         this.$emit('success')
                    //         if(closemodal)
                    //             this.closeModal()
                    //     }

                    //     return
                    // }
                })
                .catch( error => {
                    this.catchError(error)
                })
        },

        openLoading(title) {
            Swal.fire({
                title,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
        },

        stopLoading() {
            Swal.close()
        },

        showMessage(title, text, icon, redirectTo, emitMessage, emitEvent, response) {
            Swal.fire({
                title,
                html: text,
                icon,
                willClose: () => {
                    if(redirectTo != '')
                        this.$router.push(redirectTo)
                    if(emitMessage == 1)
                        $('.modal').modal('hide')
                }
            })
        },

        catchError( error ) {
            this.stopLoading()
            if (error.response.status == 401)
                this.$router.replace('/login')
            if (error.response.status == 500)
                this.showMessage('Error', error.response.statusText + ' ' + error.response.data.message, 'error', '', 0, '', '')
            if (error.response.status == 404)
                this.showMessage('Error', error.response.statusText, 'error', '', 0, '', '')
            if (error.response.status == 405)
                this.showMessage('Error', error.response.statusText, 'error', '', 0, '', '')
            if (error.response.status == 422) {
                let messages = ''
                if(error.response.data.errors) {
                    let arrayErrors = Object.values(error.response.data.errors)
                    arrayErrors.forEach(element => {
                        messages += element + '<br>'
                    })
                } else {
                    messages = error.response.data.message
                }
                this.showMessage('Error', messages, 'error', '', 0, '', '')
            }
        },
    }
}

export default globalFunctions